module.exports = __webpack_public_path__ + "static/media/Agency Admin Guide Revised.660c3c57.pdf";